/**
 * Vuex module to sort SMS conversations
 */

import ChatLocalStorage from '@/api/chat'

const actions = {
  setProperty ({ commit }, property) {
    commit('SET_PROPERTY', property)
    ChatLocalStorage.setSmsSortProperty(property)
    this.dispatch('chat/SmsSortByFilter/sortSms')
  },
  setDirection ({ commit }, direction) {
    commit('SET_DIRECTION', direction)
    ChatLocalStorage.setSmsSortDirection(direction)
    this.dispatch('chat/SmsSortByFilter/sortSms')
  },
  sortSms () {
    this.dispatch('chat/getSmsMessages')
  },
  init ({ commit }) {
    commit('SET_PROPERTY', 'recent_activity')
    commit('SET_DIRECTION', ChatLocalStorage.smsSortDirection())
  }
}

const mutations = {
  SET_PROPERTY (state, property) {
    state.property = property
  },
  SET_DIRECTION (state, direction) {
    state.direction = direction
  }
}

const state = {
  directions: ['asc', 'desc'],
  property: 'recent_activity',
  direction: 'asc'
}

const getters = {
  directions: state => state.directions,
  property: state => state.property,
  direction: state => state.direction
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
